import PropTypes from "prop-types"
import React from "react"

class ManageContentEditor extends React.Component {
  getChildContext() {
    const context = { exitEditor: this.props.onExitEditor }
    return context
  }

  render() {
    const { activeMethod, methods, step } = this.props

    const MethodForm = methods[activeMethod].form

    const handleBlocksCompletion = (blocksCompletion) => {
      console.log(
        "Ignoring blocks completion in legacy editor",
        blocksCompletion
      )
    }

    let props = {}

    if (activeMethod === "blocks") {
      props = {
        step,
        handleBlocksCompletion
      }
    }

    return (
      <div className="ManageContent__Editor">
        <MethodForm {...props} />
      </div>
    )
  }
}

ManageContentEditor.displayName = "ManageContentEditor"

ManageContentEditor.childContextTypes =
  // allow any child component to clear method
  { exitEditor: PropTypes.func }

export default ManageContentEditor
